<template>
  <div>
    <font-awesome-icon
      :class="{'_mr-2': !useDescriptionOnlyForScreenReader}"
      aria-hidden="true"
      focusable="false"
      :icon="[iconFamily, iconName]"
    />
    <span :class="{'sr-only': useDescriptionOnlyForScreenReader}">{{ description }}</span>
  </div>
</template>

<script>
export default {
  name: 'AccessibleIcon',
  props: {
    iconFamily: {
      type: String,
      required: false,
      default: 'fal'
    },
    iconName: {
      type: String,
      required: false,
      default: 'question-circle'
    },
    description: {
      type: String,
      required: true
    },
    useDescriptionOnlyForScreenReader: {
      type: Boolean,
      required: false,
      default: true
    }
  }
}
</script>

<style lang="scss" scoped>
    @import '~stylesheets/base';
</style>
